import './ScrollProgress.css';

/** Thin gradient bar at the top of the viewport that tracks scroll progress. */
export function ScrollProgress() {
  return <div className="scroll-progress" aria-hidden />;
}
